import { useFormats } from "@portal/hooks/use-formats";
import { Style } from "@portal/lib/style/style";
import { GrowCurrencyText } from "@sinecycle/growcomponents";
import { Divider } from "antd";
import { Flex } from "../Flex/Flex";
import { TypographyText } from "../Typography/AntTypography";
import { CurrencyList } from "./CurrencyList";
import { MultiCurrencyProps } from "./types";
const t = {
  title: "Multi Currency Split",
  total: "Total",
};

const currencyListPredicate = (
  currencyItem: MultiCurrencyProps["multiCurrencySplit"][number]
) => <CurrencyList {...currencyItem} key={currencyItem.value} />;

const StyledDivider = Style(Divider, {
  margin: "8px 0 12px 0",
});
function MultiCurrencyData(props: MultiCurrencyProps) {
  const { multiCurrencySplit, splitTotal } = props;
  const { locale } = useFormats();
  const Title = (
    <TypographyText strong fs="16">
      {t.title}
    </TypographyText>
  );
  const CurrencyList = (
    <Flex vertical align="start" space="12">
      {multiCurrencySplit.map(currencyListPredicate)}
    </Flex>
  );
  const Total = (
    <Flex space="32" justify="space-between">
      <TypographyText strong>{t.total}</TypographyText>
      <GrowCurrencyText
        amount={splitTotal.amount}
        options={{
          currency: splitTotal.currency,
          locale,
        }}
        textProps={{ strong: true }}
      />
    </Flex>
  );

  return (
    <div>
      {Title}
      {<StyledDivider />}
      {CurrencyList}
      {<StyledDivider />}
      {Total}
    </div>
  );
}

export { MultiCurrencyData };
